<template>
  <Shares
      :title="$t('app.label.groupsShares')"
      :shareTooltip="$t('app.tooltip.shareWithGroup')"
      addBtnId="btn_add_group_shares"
      cancelBtnId="btn_cancel_group_shares"
      saveBtnId="btn_save_group_shares"
      deleteBtnId="btn_delete_group_share"
      :shares="groupsShares"
      :unassigned="unassignedGroups"
      @add-mode="addMode"
  ></Shares>
</template>

<script>
import Shares from "./Shares";
import {mapState, mapActions} from "vuex";

export default {
  components: {
    Shares
  },
  provide: function () {
    return {
      assignedValue: this.assignedValue,
      assignedText: this.assignedText,
      unassignedValue: this.unassignedValue,
      unassignedText: this.unassignedText,
      shareWith: this.shareWithGroups,
      deleteShareWith: this.deleteShareWithGroupAndEmit,
      twoLineValue: null
    };
  },
  computed: {
    ...mapState("projectShares", ["groupsShares", "unassignedGroups"])
  },
  methods: {
    ...mapActions("projectShares", ["shareWithGroups", "deleteShareWithGroup"]),
    async deleteShareWithGroupAndEmit(groupName) {
      await this.deleteShareWithGroup(groupName)
      this.$emit("share-deleted", groupName)
    },
    addMode(mode) {
      this.$emit("add-mode", mode)
    },
    unassignedText(item) {
      return item.label
    },
    unassignedValue(item) {
      return item.name
    },
    assignedText(item) {
      return item.group.label
    },
    assignedValue(item) {
      return item.group.name
    },
  }
}
</script>